import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import {
  WorkshopCalender,
  WorkshopTime,
  WorkshopLocation,
} from "../../../app-constants-updated";
import { HomeUpdatedPackTick } from "../../../app-constants";
function Partner(props) {
  return (
    <section className="tekrevol__partner workshop-event-details overflow-x-hidden p-100">
      <Container>
        <Row className="justify-content-evenly">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-lg-0 mb-4">
            <div className="example example-bottom" data-text="Event">
              <h2>
                Event Details
                <br className="d-xl-block d-none" />
              </h2>
            </div>
            <div className="content content-left">
              <ul className="text-white">
                <li>
                  <div className="icon">{WorkshopCalender}</div>
                  <span className="title">Date :</span>
                  <span className="value">Tuesday, 03rd December 2024</span>
                </li>
                <li>
                  <div className="icon">{WorkshopTime}</div>
                  <span className="title">Time : </span>
                  <span className="value">08:00 PM GST, 10:00 AM CT</span>
                </li>
                {/* <li>
                  <div className="icon">{WorkshopLocation}</div>
                  <span className="title">Location : </span>
                  <span className="value">
                    TH 7 FL 3, Block 3 Gulshan-e-Iqbal, Karachi, Karachi City,
                    Sindh 75300
                  </span>
                </li> */}
              </ul>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="example example-bottom" data-text="Info">
              <h2>
                What You’ll Get
                <br className="d-xl-block d-none" />
              </h2>
            </div>
            <div className="content content-right">
              <ul className="text-white">
                <li>
                  <div className="img">{HomeUpdatedPackTick}</div>Access to the
                  live workshop session
                </li>
                <li>
                  <div className="img">{HomeUpdatedPackTick}</div>Downloadable
                  business plan template
                </li>
                <li>
                  <div className="img">{HomeUpdatedPackTick}</div>Certificate of
                  participation
                </li>
                <li>
                  <div className="img">{HomeUpdatedPackTick}</div>Live
                  Instruction and Feedback
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Partner;
